// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8999) return "static/chunks/8999-043e154ed74d34f3.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6925 ? "2c386607" : chunkId) + "." + {"3734":"56e864fca5dfb4bc","5369":"9470b6256c7af910","5676":"53b5383fc5a4c5f6","6925":"28434519959a0456"}[chunkId] + ".js";
};